import dateTimeUtils from "../../../utils/dateTimeUtils";
import PublishStatusCard from "../PublishStatusCard";

import { type CardBase } from "../../../interfaces";

import { faFolderOpen } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./ScormCard.module.scss";

interface Props extends CardBase {
  item: CardBase["item"] & {
    visibility?: boolean;
  };
}

export const ScormCard = (props: Props) => {
  const { item, onSelect, disabled, url, popupMenu, selected } = props;

  return (
    <PublishStatusCard
      id={item.id}
      title={item.title}
      thumbnailUrl={item.thumbnailUrl}
      publisher={item.publisher}
      published={!item.isDraft}
      hasBeenPublished={item.hasBeenPublished}
      disabled={disabled}
      url={url}
      selected={selected}
      popupMenu={popupMenu}
      onSelectionChanged={onSelect}
      className={styles.root}
      isHidden={!item.visibility}
      placeholderContent={
        <div className={styles.thumbnailBlock}>
          <FontAwesomeIcon icon={faFolderOpen} color={"#686569"} size={"3x"} />
        </div>
      }
    >
      <div className={styles["date-added"]}>Added {dateTimeUtils.formatDate(item.dateCreated)}</div>
    </PublishStatusCard>
  );
};
